// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.dashboard-container {
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  background: linear-gradient(135deg, #f0f4f8 0%, #d9e2ec 100%);
}

.dashboard-header {
  background: var(--primary-color);
  padding: 1rem 2rem;
  color: var(--white);
  box-shadow: var(--shadow-lg);
  position: sticky;
  top: 0;
  z-index: 100;
}

.header-content {
  max-width: 1400px;
  margin: 0 auto;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.header-left {
  display: flex;
  align-items: center;
  gap: 2rem;
}

.header-left h1 {
  font-size: 1.5rem;
  font-weight: 700;
  color: var(--white);
}

.admin-info {
  display: flex;
  align-items: center;
  gap: 0.75rem;
  padding: 0.5rem 1rem;
  background: rgba(255, 255, 255, 0.1);
  border-radius: var(--radius-lg);
}

.user-icon {
  font-size: 1.25rem;
}

.user-details {
  display: flex;
  flex-direction: column;
}

.user-email {
  font-weight: 600;
  font-size: 0.875rem;
}

.user-role {
  font-size: 0.75rem;
  color: var(--secondary-color);
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.logout-button {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  padding: 0.5rem 1rem;
  background: rgba(239, 68, 68, 0.1);
  color: #f87171;
  border: 1px solid rgba(239, 68, 68, 0.2);
  border-radius: var(--radius-md);
  font-weight: 500;
  font-size: 0.875rem;
  font-family: 'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;
  letter-spacing: 0.025em;
}

.logout-button:hover {
  background: #ef4444;
  color: var(--white);
  transform: translateY(-2px);
}

.dashboard-main {
  flex: 1 1;
  padding: 2rem;
}

.dashboard-controls {
  background: rgba(255, 255, 255, 0.8);
  backdrop-filter: blur(12px);
  padding: 1.5rem;
  border-radius: var(--radius-xl);
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 2rem;
  box-shadow: var(--shadow-md);
  border: 1px solid rgba(255, 255, 255, 0.5);
}

.controls-left {
  display: flex;
  align-items: center;
  gap: 2rem;
}

.controls-right {
  display: flex;
  gap: 1rem;
}

.add-button {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  padding: 0.4rem 0.75rem;
  background: var(--secondary-color);
  color: var(--white);
  border: none;
  border-radius: var(--radius-md);
  font-weight: 500;
  font-size: 0.8rem;
  font-family: 'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;
  letter-spacing: 0.025em;
  box-shadow: var(--shadow-md);
}

.add-button:hover {
  background: var(--secondary-hover);
  transform: translateY(-2px);
  box-shadow: var(--shadow-lg);
}

.view-public-button {
  padding: 0.4rem 0.75rem;
  background: var(--white);
  color: var(--primary-color);
  border: 1px solid var(--primary-color);
  border-radius: var(--radius-md);
  font-weight: 500;
  font-size: 0.8rem;
  font-family: 'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;
  letter-spacing: 0.025em;
  transition: all 0.3s ease;
}

.view-public-button:hover {
  background: var(--primary-color);
  color: var(--white);
}

.actions {
  display: flex;
  gap: 0.5rem;
}

.edit-button, .delete-button {
  padding: 0.4rem 0.6rem;
  border-radius: var(--radius-md);
  font-size: 0.8rem;
  font-weight: 500;
  font-family: 'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;
  letter-spacing: 0.02em;
  border: none;
  display: flex;
  align-items: center;
  gap: 0.25rem;
}

.edit-button {
  background: #eff6ff;
  color: #3b82f6;
}

.edit-button:hover {
  background: #3b82f6;
  color: var(--white);
}

.delete-button {
  background: #fef2f2;
  color: #ef4444;
}

.delete-button:hover {
  background: #ef4444;
  color: var(--white);
}

.dashboard-error, .dashboard-success {
  padding: 1rem;
  border-radius: var(--radius-md);
  margin-bottom: 2rem;
  text-align: center;
  font-weight: 500;
  animation: fadeIn 0.4s ease;
}

.dashboard-footer {
  background: var(--white);
  padding: 2rem;
  text-align: center;
  border-top: 1px solid rgba(0, 0, 0, 0.05);
  display: flex;
  justify-content: center;
}

/* Mobile Responsiveness */
@media (max-width: 768px) {
  .header-content {
    flex-direction: column;
    gap: 1.5rem;
  }
  .header-left {
    flex-direction: column;
    gap: 1rem;
    text-align: center;
  }
  .dashboard-controls {
    flex-direction: column;
    gap: 1rem;
    padding: 1rem;
  }
  .controls-left, .controls-right {
    flex-direction: column;
    width: 100%;
    gap: 1rem;
  }
  .search-box {
    width: 100%;
  }
  .add-button, .view-public-button {
    width: 100%;
    justify-content: center;
  }
  .dashboard-main {
    padding: 1rem;
  }
  .actions {
    flex-direction: column;
  }
}`, "",{"version":3,"sources":["webpack://./src/styles/AdminDashboard.css"],"names":[],"mappings":"AAAA;EACE,iBAAiB;EACjB,aAAa;EACb,sBAAsB;EACtB,6DAA6D;AAC/D;;AAEA;EACE,gCAAgC;EAChC,kBAAkB;EAClB,mBAAmB;EACnB,4BAA4B;EAC5B,gBAAgB;EAChB,MAAM;EACN,YAAY;AACd;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,oBAAoB;EACpB,oCAAoC;EACpC,+BAA+B;AACjC;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,6BAA6B;EAC7B,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,oBAAoB;EACpB,kCAAkC;EAClC,cAAc;EACd,wCAAwC;EACxC,+BAA+B;EAC/B,gBAAgB;EAChB,mBAAmB;EACnB,uFAAuF;EACvF,uBAAuB;AACzB;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;EACnB,2BAA2B;AAC7B;;AAEA;EACE,SAAO;EACP,aAAa;AACf;;AAEA;EACE,oCAAoC;EACpC,2BAA2B;EAC3B,eAAe;EACf,+BAA+B;EAC/B,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;EACnB,4BAA4B;EAC5B,0CAA0C;AAC5C;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,uBAAuB;EACvB,kCAAkC;EAClC,mBAAmB;EACnB,YAAY;EACZ,+BAA+B;EAC/B,gBAAgB;EAChB,iBAAiB;EACjB,uFAAuF;EACvF,uBAAuB;EACvB,4BAA4B;AAC9B;;AAEA;EACE,kCAAkC;EAClC,2BAA2B;EAC3B,4BAA4B;AAC9B;;AAEA;EACE,uBAAuB;EACvB,wBAAwB;EACxB,2BAA2B;EAC3B,sCAAsC;EACtC,+BAA+B;EAC/B,gBAAgB;EAChB,iBAAiB;EACjB,uFAAuF;EACvF,uBAAuB;EACvB,yBAAyB;AAC3B;;AAEA;EACE,gCAAgC;EAChC,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,WAAW;AACb;;AAEA;EACE,sBAAsB;EACtB,+BAA+B;EAC/B,iBAAiB;EACjB,gBAAgB;EAChB,uFAAuF;EACvF,sBAAsB;EACtB,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,+BAA+B;EAC/B,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,2BAA2B;AAC7B;;AAEA;EACE,wBAAwB;EACxB,aAAa;EACb,kBAAkB;EAClB,yCAAyC;EACzC,aAAa;EACb,uBAAuB;AACzB;;AAEA,0BAA0B;AAC1B;EACE;IACE,sBAAsB;IACtB,WAAW;EACb;EACA;IACE,sBAAsB;IACtB,SAAS;IACT,kBAAkB;EACpB;EACA;IACE,sBAAsB;IACtB,SAAS;IACT,aAAa;EACf;EACA;IACE,sBAAsB;IACtB,WAAW;IACX,SAAS;EACX;EACA;IACE,WAAW;EACb;EACA;IACE,WAAW;IACX,uBAAuB;EACzB;EACA;IACE,aAAa;EACf;EACA;IACE,sBAAsB;EACxB;AACF","sourcesContent":[".dashboard-container {\n  min-height: 100vh;\n  display: flex;\n  flex-direction: column;\n  background: linear-gradient(135deg, #f0f4f8 0%, #d9e2ec 100%);\n}\n\n.dashboard-header {\n  background: var(--primary-color);\n  padding: 1rem 2rem;\n  color: var(--white);\n  box-shadow: var(--shadow-lg);\n  position: sticky;\n  top: 0;\n  z-index: 100;\n}\n\n.header-content {\n  max-width: 1400px;\n  margin: 0 auto;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n}\n\n.header-left {\n  display: flex;\n  align-items: center;\n  gap: 2rem;\n}\n\n.header-left h1 {\n  font-size: 1.5rem;\n  font-weight: 700;\n  color: var(--white);\n}\n\n.admin-info {\n  display: flex;\n  align-items: center;\n  gap: 0.75rem;\n  padding: 0.5rem 1rem;\n  background: rgba(255, 255, 255, 0.1);\n  border-radius: var(--radius-lg);\n}\n\n.user-icon {\n  font-size: 1.25rem;\n}\n\n.user-details {\n  display: flex;\n  flex-direction: column;\n}\n\n.user-email {\n  font-weight: 600;\n  font-size: 0.875rem;\n}\n\n.user-role {\n  font-size: 0.75rem;\n  color: var(--secondary-color);\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n}\n\n.logout-button {\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n  padding: 0.5rem 1rem;\n  background: rgba(239, 68, 68, 0.1);\n  color: #f87171;\n  border: 1px solid rgba(239, 68, 68, 0.2);\n  border-radius: var(--radius-md);\n  font-weight: 500;\n  font-size: 0.875rem;\n  font-family: 'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;\n  letter-spacing: 0.025em;\n}\n\n.logout-button:hover {\n  background: #ef4444;\n  color: var(--white);\n  transform: translateY(-2px);\n}\n\n.dashboard-main {\n  flex: 1;\n  padding: 2rem;\n}\n\n.dashboard-controls {\n  background: rgba(255, 255, 255, 0.8);\n  backdrop-filter: blur(12px);\n  padding: 1.5rem;\n  border-radius: var(--radius-xl);\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 2rem;\n  box-shadow: var(--shadow-md);\n  border: 1px solid rgba(255, 255, 255, 0.5);\n}\n\n.controls-left {\n  display: flex;\n  align-items: center;\n  gap: 2rem;\n}\n\n.controls-right {\n  display: flex;\n  gap: 1rem;\n}\n\n.add-button {\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n  padding: 0.4rem 0.75rem;\n  background: var(--secondary-color);\n  color: var(--white);\n  border: none;\n  border-radius: var(--radius-md);\n  font-weight: 500;\n  font-size: 0.8rem;\n  font-family: 'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;\n  letter-spacing: 0.025em;\n  box-shadow: var(--shadow-md);\n}\n\n.add-button:hover {\n  background: var(--secondary-hover);\n  transform: translateY(-2px);\n  box-shadow: var(--shadow-lg);\n}\n\n.view-public-button {\n  padding: 0.4rem 0.75rem;\n  background: var(--white);\n  color: var(--primary-color);\n  border: 1px solid var(--primary-color);\n  border-radius: var(--radius-md);\n  font-weight: 500;\n  font-size: 0.8rem;\n  font-family: 'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;\n  letter-spacing: 0.025em;\n  transition: all 0.3s ease;\n}\n\n.view-public-button:hover {\n  background: var(--primary-color);\n  color: var(--white);\n}\n\n.actions {\n  display: flex;\n  gap: 0.5rem;\n}\n\n.edit-button, .delete-button {\n  padding: 0.4rem 0.6rem;\n  border-radius: var(--radius-md);\n  font-size: 0.8rem;\n  font-weight: 500;\n  font-family: 'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;\n  letter-spacing: 0.02em;\n  border: none;\n  display: flex;\n  align-items: center;\n  gap: 0.25rem;\n}\n\n.edit-button {\n  background: #eff6ff;\n  color: #3b82f6;\n}\n\n.edit-button:hover {\n  background: #3b82f6;\n  color: var(--white);\n}\n\n.delete-button {\n  background: #fef2f2;\n  color: #ef4444;\n}\n\n.delete-button:hover {\n  background: #ef4444;\n  color: var(--white);\n}\n\n.dashboard-error, .dashboard-success {\n  padding: 1rem;\n  border-radius: var(--radius-md);\n  margin-bottom: 2rem;\n  text-align: center;\n  font-weight: 500;\n  animation: fadeIn 0.4s ease;\n}\n\n.dashboard-footer {\n  background: var(--white);\n  padding: 2rem;\n  text-align: center;\n  border-top: 1px solid rgba(0, 0, 0, 0.05);\n  display: flex;\n  justify-content: center;\n}\n\n/* Mobile Responsiveness */\n@media (max-width: 768px) {\n  .header-content {\n    flex-direction: column;\n    gap: 1.5rem;\n  }\n  .header-left {\n    flex-direction: column;\n    gap: 1rem;\n    text-align: center;\n  }\n  .dashboard-controls {\n    flex-direction: column;\n    gap: 1rem;\n    padding: 1rem;\n  }\n  .controls-left, .controls-right {\n    flex-direction: column;\n    width: 100%;\n    gap: 1rem;\n  }\n  .search-box {\n    width: 100%;\n  }\n  .add-button, .view-public-button {\n    width: 100%;\n    justify-content: center;\n  }\n  .dashboard-main {\n    padding: 1rem;\n  }\n  .actions {\n    flex-direction: column;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
